import { DecorationSet, EditorView } from '@atlaskit/editor-prosemirror/view';

export interface StartAction {
	type: 'START';
	data: {
		innerEditorView: EditorView;
		decorationSet: DecorationSet;
	};
}

export interface EndAction {
	type: 'END';
}

export interface InEditorStreamingPluginState {
	decorationSet: DecorationSet;
	innerEditorView?: EditorView;
}

export function reducer(
	state: InEditorStreamingPluginState,
	action: StartAction | EndAction,
): InEditorStreamingPluginState {
	switch (action.type) {
		case 'START': {
			return {
				...state,
				decorationSet: action.data.decorationSet,
				innerEditorView: action.data.innerEditorView,
			};
		}
		case 'END': {
			if (state.innerEditorView) {
				state.innerEditorView.destroy();
			}
			return {
				...state,
				innerEditorView: undefined,
				decorationSet: DecorationSet.empty,
			};
		}
		default:
			return state;
	}
}
